import { tutorApiService } from "../../network/TutorApiService";
import {
  disconnectSocket,
  socketInitialisation,
} from "../../network/SocketOperation";
import { handleRemoveExtraSpace } from "../../utils/TutorConstants";
import { redirectToLoginPage } from "../login-service";

const fetchWelcomeClassifier = async (
  setClassifierInfo,
  setShowLoader,
  body,
  setIsStreamingCompleted
) => {
  socketInitialisation();
  let headers = {};
  const response = await tutorApiService("/ai-assist/welcome-classify", {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  setShowLoader(false);
  if (response.status == 200 || response.status == 201) {
    const reader = response.body.getReader();
    setIsStreamingCompleted(true);
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        setIsStreamingCompleted(false);
        return handleResponse(response, setClassifierInfo);
      }
      let chunk = new TextDecoder().decode(value);
      handleUpdateChunk(chunk, setClassifierInfo);
    }
  } else if (response.status == 401) {
    //redirect login page added
    redirectToLoginPage();
  } else {
    setShowLoader(false);
    return handleError();
  }
};
const handleResponse = (response, setClassifierInfo) => {
  disconnectSocket();
  const status = response.headers.get("welcome_classify_status_key");
  setClassifierInfo((prev) => {
    return { ...prev, classifierStatus: status };
  });
  return status;
};
const handleError = () => {
  disconnectSocket();
  return null;
};
const handleUpdateChunk = (chunk, setClassifierInfo) => {
  // chunk = chunk?.replace(/\n/g, " ");
  setClassifierInfo((prev) => {
    let existingStr = prev?.classifierText?.toString() || "";
    return {
      ...prev,
      classifierText: handleRemoveExtraSpace(existingStr.concat(chunk)),
    };
  });
};

export { fetchWelcomeClassifier };
